import { MANAGE_PRODUCTS, ORDER_DETAILS, PROFILE_SETTINGS } from "../../../constants/seller-center-paths";

export const WEBSITE_SECTIONS = {
    SELLER_CENTER: 'seller_center'
  };

  export const PAGE_TYPES = {
    DASHBOARD: 'dashboard',
    MANAGE_PRODUCTS: 'manage_products',
    ADD_PRODUCT: 'add_product',
    EDIT_PRODUCT: 'edit_product',
    MANAGE_USERS: 'manage_users',
    PROFILE_SETTINGS: 'profile_settings',
    SHIPMENTS: 'shipments',
    REVIEWS: 'reviews',
    ORDER_DETAILS: 'order_details',
    MANAGE_ORDERS: 'manage_orders'
  };

  // CATEGORY NAMES
  export const EVENT_CATEGORIES = {
    PAGEVIEW: 'Pageview',
    CLICK: 'click',
  };

  // ACTION NAMES
  export const EVENT_NAMES = {
    PAGE_VIEW: 'page_view',
    CHAT: 'chat',
    SEARCH: 'search',
    MANAGE_ORDERS: 'manage_orders',
    ADD_PRODUCT: 'add_product',
    ORDER_DETAILS: 'order_details',
    CANCEL_ORDER: 'cancel_order',
    UPDATE_STOCK: 'update_stock',
    EDIT_PRODUCT: 'edit_product',
    SHARE_PRODUCT: 'share_product',
    DELETE_PRODUCT: 'delete_product',
    REVIEW_REPLY: 'review_reply',
    SUBMIT_PRODUCT: 'submit_product',
    ADD_USER: 'add_user',
    REMOVE_USER: 'remove_user',
    EDIT_USER: 'edit_user',
    BASIC_INFO: 'save_basic_info',
    WAREHOUSE_LOC: 'warehouse_location_save',
    PRINT_LABEL: 'print_label',
    REVIEW_REPLY: 'review_reply',
    UPDATE_PRODUCT: 'update_product'
  };

  export const STRINGS = {
    NEW: 'new',
    EDIT: 'edit',
    ERROR: 'error',
    SUCCESS: 'success',
    YES: 'yes',
    NO: 'no',
    TRUE: 'true',
    FALSE: 'false',
  };

  export const PAGE_SECTIONS = {
    HEADER: 'header',
    PENDING_ORDERS: "pending_orders",
    PRODUCT_LISTING: 'product_listing',
    SHIPMENT_LISTING: 'shipment_listing',
    REVIEW_LISTING: 'review_listing',
    RECENT_PRODUCTS: 'recent_products',
    ORDER_LISTING: 'order_listing',
    USER_LISTING: 'user_listing',
    FORM: 'form',
    ACTION_BUTTONS: 'action_buttons'
  }

  export const LANGUAGE = {
    ENGLISH: 'en'
  }